export { COLORS, SHADOWS } from './colors';
export { CURRENCY } from './currencies';
export { LANGUAGES } from './languages';
export { STORAGE } from './storage';

export const mainBtnClassName = 'btn btn-main';
